module.exports = "{{#if url}} <span class=\"bubbles__link js-bubble-link\"> {{/if}} {{name}} {{#if url}} </span> {{/if}} <div class=\"svg-icons-wrp svg-icons-wrp_bubble\"> <div class=\"js-bubble-delete svg-icons-wrp__remove svg-icons-wrp__remove_bubble\"> <svg class=\"svg-icons svg-icons_remove-bubble\"><use xlink:href=#icon-remove /> </svg> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/membersBubble/templates/bubble.hbs
// module id = 667
// module chunks = 0